<template>
    <div class="header-block">
        <img
            class="main-logo"
            :src="require('@/assets/main_logo.png')"
            alt="Main logo"
        >
        <v-card color="black" class="rounded-xl" style="min-width: 350px;">
            <div v-if="!match.cup" class="custom-orange-text font-weight-bold py-6 px-10">
                {{ match.league.title }}
            </div>
            <div v-else class="custom-orange-text font-weight-bold py-6 px-10">
                Cup
            </div>
        </v-card>
        <v-card color="black" class="rounded-lg" style="min-width: 500px;">
            <div class="white--text font-weight-bold py-6 px-10">
                {{ roundLabel }}
            </div>
        </v-card>
    </div>
</template>

<script>
    export default {
        name: 'MatchInfoHeader',
        props: {
            match: {
                type: Object,
                required: true
            }
        },
        computed: {
            roundLabel() {
                const phaseLabel = this.match.cup
                    ? 'Κύπελλο'
                    : (this.match.phase === 'regular_season' ? 'Regular Season' : (this.match.phase === 'placements' ? 'Προκριματικά' : 'Play Offs'))
                return `Round ${this.match.round}, ${phaseLabel}`
            }
        }
    }
</script>

<style scoped>
.header-block {
    position: absolute;
    top: 12px;
    left: 105px;
    z-index: 5;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.main-logo {
    width: clamp(160px, 24vw, 280px);
    height: auto;
    pointer-events: none;
}
</style>
